
import { Grid, Container } from "@utilitywarehouse/hearth-react";

import VulnerabilityContextProvider from "../context/vulnerability/VulnerabilityContextProvider";

import Footer from "./Footer";
import { Navbar } from "./Navbar";

const Layout: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return (
      <Grid
        backgroundColor="primary"
        margin="0"
        minHeight="100vh"
        templateRows="auto 1fr auto"
      >
        <VulnerabilityContextProvider>          
          <Navbar />

          <Container>
            {children}
          </Container>

          <Footer />
        </VulnerabilityContextProvider>
      </Grid>
  );
};

export default Layout;
